export const environment = {
  production: true,
  apiUrl: 'https://api3-wh.sentrixbar.com/api/v1/',
  socketUrl: 'wss://api3-wh.sentrixbar.com/',
  loginUrl: 'https://api3-wh.sentrixbar.com/api/v1/',
  apiUrlV1: 'https://api3-wh.sentrixbar.com/api/v1/',
};
